import React, { useEffect } from "react";

const WhatsAppIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.83574 12.3296L5.31889 12.6113C6.12606 13.082 7.0434 13.3333 8.00066 13.3333C10.9462 13.3333 13.334 10.9455 13.334 7.99998C13.334 5.05446 10.9462 2.66665 8.00066 2.66665C5.05513 2.66665 2.66732 5.05446 2.66732 7.99998C2.66732 8.95751 2.9188 9.87518 3.38977 10.6825L3.67136 11.1652L3.2357 12.7662L4.83574 12.3296ZM1.33677 14.6666L2.23808 11.3543C1.66329 10.369 1.33398 9.22298 1.33398 7.99998C1.33398 4.31808 4.31875 1.33331 8.00066 1.33331C11.6825 1.33331 14.6673 4.31808 14.6673 7.99998C14.6673 11.6818 11.6825 14.6666 8.00066 14.6666C6.77806 14.6666 5.63234 14.3376 4.64724 13.7631L1.33677 14.6666Z"
      fill="white"
    />
  </svg>
);

const buildWhatsAppLink = (number, prefilledText) => {
  if (!number) return "#contact";

  // Strip non-digits except leading +
  const cleanNumber = String(number)
    .replace(/[^\d+]/g, "")
    .replace(/^\+/, "");
  const encodedText = encodeURIComponent(prefilledText || "");

  return `https://wa.me/${cleanNumber}${encodedText ? `?text=${encodedText}` : ""}`;
};

const ContactBtn = ({ whatsappNumber, whatsappPrefilledText }) => {
  const link = buildWhatsAppLink(whatsappNumber, whatsappPrefilledText);
  return (
    <a
      href={link}
      className="connect-btn"
      target="_blank"
      rel="noopener noreferrer"
    >
      <WhatsAppIcon />
      Contact
    </a>
  );
};

// On-screen carousel (flat image array)
const AccordionSlider = ({ images }) => (
  <div className="accordian-slider owl-carousel">
    {images.map((img, idx) => {
      const url = typeof img === "string" ? img : img.url;
      const caption = typeof img === "string" ? "" : img.caption;
      return (
        <div className="figure" key={idx}>
          <img src={url} alt={caption || ""} />
          {caption && <span>{caption}</span>}
        </div>
      );
    })}
  </div>
);

// Off-screen card columns (image objects with title + items)
// Supports both legacy cards ({title, image, items}) and new image objects ({url, caption})
const OffscreenCards = ({ imageCards }) => (
  <div className="row">
    {imageCards.map((card, idx) => {
      const isLegacyCard = card && card.image !== undefined;
      const imgSrc = isLegacyCard ? card.image : card.url;
      const caption = isLegacyCard ? card.title : card.caption;
      const items = isLegacyCard ? card.items : null;

      return (
        <div className="col-lg-4 col-md-4 col-sm-12" key={idx}>
          <div className="figure" style={{ marginBottom: 16 }}>
            <img
              src={imgSrc}
              alt={caption || ""}
              style={{ width: "100%", borderRadius: 10 }}
            />
            {caption && <span>{caption}</span>}
          </div>
          {items && items.length > 0 && (
            <ul className="list">
              {items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      );
    })}
  </div>
);

const AdvertiseSection = ({ tabs, sections }) => {
  // Group sections by tab_group
  const sectionsByTab = {};
  sections.forEach((section) => {
    const tabGroup = section.data?.tab_group || section.id;
    if (!sectionsByTab[tabGroup]) {
      sectionsByTab[tabGroup] = [];
    }
    sectionsByTab[tabGroup].push(section);
  });

  // If no tabs provided, use default tabs
  const displayTabs =
    tabs && tabs.length > 0
      ? tabs
      : [
          { slug: "onscreen", title: "On-Screen Advertisements" },
          { slug: "offscreen", title: "Off-Screen Advertising" },
        ];

  useEffect(() => {
    const $ = window.$;
    if ($ && $.fn && $.fn.owlCarousel) {
      $(".accordian-slider").owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: true,
        responsive: {
          0: { items: 1 },
          600: { items: 2 },
          900: { items: 3 },
        },
      });
    }
  }, []);

  return (
    <div className="advertise-section">
      <div className="container text-center">
        <div className="row">
          {/* ── Tab nav ── */}
          <ul
            className="nav nav-pills justify-content-center hori-tab"
            id="pills-tab"
            role="tablist"
          >
            {displayTabs.map((tab, idx) => (
              <li className="nav-item" role="presentation" key={tab.slug}>
                <button
                  className={idx === 0 ? "active" : ""}
                  id={`pills-${tab.slug}-tab`}
                  data-bs-toggle="pill"
                  data-bs-target={`#pills-${tab.slug}`}
                  type="button"
                  role="tab"
                  aria-controls={`pills-${tab.slug}`}
                  aria-selected={idx === 0 ? "true" : "false"}
                >
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M16.6667 2.5H3.33332C2.41285 2.5 1.66666 3.24619 1.66666 4.16667V12.5C1.66666 13.4205 2.41285 14.1667 3.33332 14.1667H16.6667C17.5871 14.1667 18.3333 13.4205 18.3333 12.5V4.16667C18.3333 3.24619 17.5871 2.5 16.6667 2.5Z"
                        stroke="white"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M6.66666 17.5H13.3333"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10 14.1667V17.5"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  {tab.title}
                </button>
              </li>
            ))}
          </ul>

          {/* ── Tab content ── */}
          <div className="tab-content" id="pills-tabContent">
            {displayTabs.map((tab, tabIdx) => {
              const tabKey = tab.tab_group || tab.slug;
              const tabSections = sectionsByTab[tabKey] || [];
              return (
                <div
                  key={tab.slug}
                  className={`tab-pane fade${tabIdx === 0 ? " show active" : ""}`}
                  id={`pills-${tab.slug}`}
                  role="tabpanel"
                  aria-labelledby={`pills-${tab.slug}-tab`}
                  tabIndex="0"
                >
                  <div
                    className="accordion accordion-flush accordian-th"
                    id={`accordion-${tab.slug}`}
                  >
                    {tabSections.map((s, idx) => {
                      const collapseId = `flush-collapse-${s.id}`;
                      const isFirst = idx === 0;

                      // Normalise: section may use `images` (object array) or `cards`
                      // Images are now {url, caption} objects; cards are {title, image, items}
                      const hasImageObjects =
                        Array.isArray(s.images) &&
                        s.images.length > 0 &&
                        typeof s.images[0] === "object" &&
                        s.images[0] !== null &&
                        "url" in s.images[0];

                      const imageCards = hasImageObjects
                        ? s.images
                        : Array.isArray(s.cards)
                          ? s.cards
                          : [];

                      // For the slider, only use string images (legacy) or images without cards
                      const sliderImages = Array.isArray(s.images)
                        ? s.images.filter((img) => {
                            if (typeof img === "string") return true;
                            return img && img.url;
                          })
                        : [];

                      return (
                        <div className="accordion-item" key={s.id}>
                          <h2 className="accordion-header">
                            <button
                              className={`accordion-button${isFirst ? "" : " collapsed"}`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#${collapseId}`}
                              aria-expanded={isFirst ? "true" : "false"}
                              aria-controls={collapseId}
                            >
                              {s.title}
                            </button>
                          </h2>
                          <div
                            id={collapseId}
                            className={`accordion-collapse collapse${isFirst ? " show" : ""}`}
                            data-bs-parent={`#accordion-${tab.slug}`}
                          >
                            <div className="accordion-body accordion-th">
                              {/* Image slider (only when images are plain strings or no cards) */}
                              {!hasImageObjects && sliderImages.length > 0 && (
                                <AccordionSlider images={sliderImages} />
                              )}
                              {/* Image cards (when images are objects with url+caption) */}
                              {hasImageObjects && imageCards.length > 0 && (
                                <OffscreenCards imageCards={imageCards} />
                              )}
                              {/* Legacy cards support */}
                              {!hasImageObjects &&
                                Array.isArray(s.cards) &&
                                s.cards.length > 0 && (
                                  <OffscreenCards imageCards={s.cards} />
                                )}
                              {/* Rich text content (HTML) */}
                              {s.content && (
                                <div
                                  className="rich-content"
                                  dangerouslySetInnerHTML={{
                                    __html: s.content,
                                  }}
                                />
                              )}
                              <ContactBtn
                                whatsappNumber={s.whatsapp_number}
                                whatsappPrefilledText={
                                  s.whatsapp_prefilled_text
                                }
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertiseSection;
